// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2E7D32", // Orman Yeşili (Ana Marka Rengi)
      light: "#60AD5E",
      dark: "#005005",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#795548", // Toprak Rengi
      light: "#A98274",
      dark: "#4B2C20",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ED6C02", // Kehribar (Uyarılar için)
    },
    background: {
      default: "#F4F6F8", // Sayfa arka planı
      paper: "#FFFFFF", // Kartların arka planı
    },
    text: {
      primary: "#263238", // Koyu antrasit (Okunabilirlik için)
      secondary: "#546E7A",
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
    h1: { fontFamily: "'Montserrat', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Montserrat', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
    h6: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
      letterSpacing: "0.5px",
    },
    button: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
      textTransform: "none",
    }, // Buton harfleri artık tamamen büyük değil
  },
  shape: {
    borderRadius: 12, // Daha yumuşak, modern köşeler
  },
  components: {
    // --- ORTAK BILESEN VARSAYILANLARI ---------------------------------------
    // Sayfalarin tek tek kendi koseleri / golgeleri / baslik stilleri yerine
    // butun panelin ayni yerden beslenmesi icin buraya toplandi.
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 4px 8px rgba(46, 125, 50, 0.2)",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: "1px solid #eaecf0",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 600 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "#eef0f2" },
        head: {
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 700,
          fontSize: "0.8rem",
          color: "#344054",
          backgroundColor: "#F8F9FA",
          whiteSpace: "nowrap",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none", // Dark mode gecislerinde desen olmasin
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)", // Hafif, modern gölge
          backgroundColor: "#2E7D32",
        },
      },
    },
  },
});

export default theme;
